import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CatalogsService } from 'src/app/services/catalogs-services/catalogs-services/catalogs.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { tap, catchError } from 'rxjs/operators';
import { HeaderBreadcrumbService } from '../../header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { empty } from 'rxjs';
import { CatalogBasic } from 'src/app/models/catalogs-model/catalog.model';

@Component({
  selector: 'app-catalogs-catalogs-dashboard',
  templateUrl: './catalogs-catalogs-dashboard.component.html',
  styleUrls: ['./catalogs-catalogs-dashboard.component.scss']
})
export class CatalogsCatalogsDashboardComponent implements OnInit, OnDestroy {

  catalogsList: CatalogBasic[];
  filterOpts;
  filterKey;
  noItemsConfig;
  viewDisposition = 'grid';
  getCatalogListSubscription: Subscription;
  searchCatalogsSubscription: Subscription;
  refreshCatalogsSubscription: Subscription;
  filterCatalogsSubscription: Subscription;
  toggleCatalogsDispositionSubscription: Subscription;

  constructor(private headerBreadcrumbService: HeaderBreadcrumbService,
              private snackbarService: SnackBarService,
              private cd: ChangeDetectorRef,
              private catalogsService: CatalogsService) {
                this.noItemsConfig = this.setNoItemsConfig();
              }

  ngOnInit() {
    this.setBreadcrumb();
    this.getCatalogsList();
    this.refreshCatalogsSubscription = this.catalogsService.refreshCatalogsListen().subscribe(
      (res) => {
        this.getCatalogsList();
      }
    );
    this.filterCatalogsSubscription = this.catalogsService.filterCatalogsListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchCatalogsSubscription = this.catalogsService.searchCatalogsListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleCatalogsDispositionSubscription = this.catalogsService.toggleCatalogsDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getCatalogsList() {
    this.getCatalogListSubscription = this.catalogsService.getCatalogsList().pipe(
      tap((o: CatalogBasic[]) => this.catalogsList = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return empty(); })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-book', 'catalogs-page.catalogs', '/catalog', [new BRoute('catalogs-page.catalog', '/catalog'), new BRoute('catalogs-page.catalogs')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'catalogs-page.catalogs not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngOnDestroy() {
    if (this.getCatalogListSubscription) { this.getCatalogListSubscription.unsubscribe(); }
    if (this.searchCatalogsSubscription) { this.searchCatalogsSubscription.unsubscribe(); }
    if (this.toggleCatalogsDispositionSubscription) { this.toggleCatalogsDispositionSubscription.unsubscribe(); }
    if (this.refreshCatalogsSubscription) { this.refreshCatalogsSubscription.unsubscribe(); }
    if (this.filterCatalogsSubscription) { this.filterCatalogsSubscription.unsubscribe(); }
  }
}
